import React from "react";
import { AlertCircle } from "lucide-react";
import { useMissingSummary } from "./useMissingSummary";

export default function MissingDataBanners({ navigate }) {
  const data = useMissingSummary();
  if (!data) return null;
  const items = [
    { key: "persons", label: "Persoane", icon: "👥", route: "/personal", color: "bg-violet-50 text-violet-800 border-violet-200" },
    { key: "cars", label: "Autoturisme", icon: "🚗", route: "/autoturisme", color: "bg-emerald-50 text-emerald-800 border-emerald-200" },
    { key: "projects", label: "Proiecte", icon: "📁", route: "/proiecte", color: "bg-orange-50 text-orange-800 border-orange-200" },
    { key: "regii", label: "Regii", icon: "🛠", route: "/proiecte", color: "bg-amber-50 text-amber-800 border-amber-200" },
  ];
  const present = items.filter((x) => (data[x.key] || 0) > 0);
  if (present.length === 0) return null;
  return (
    <div className="card-flat p-4 mb-4 bg-amber-50/40 border-amber-200" data-testid="missing-data-banners">
      <div className="flex items-center gap-2 mb-3">
        <AlertCircle size={18} className="text-amber-700"/>
        <h3 className="font-display font-bold text-sm text-amber-900">Date de completat — sumar global</h3>
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-4 gap-2">
        {present.map((x) => (
          <button
            key={x.key}
            type="button"
            onClick={() => navigate(x.route)}
            className={`card-flat p-3 hover:scale-[1.02] transition-transform border ${x.color} text-left`}
            data-testid={`missing-data-${x.key}`}
          >
            <div className="text-2xl">{x.icon}</div>
            <div className="font-display text-xl font-bold mt-1">{data[x.key]}</div>
            <div className="text-[10px] uppercase font-semibold tracking-wider opacity-80">{x.label} cu date lipsă</div>
          </button>
        ))}
      </div>
    </div>
  );
}
